import React from 'react';
import {useLocation} from 'react-router-dom';
import axios from 'axios';
import {PAGE_VIEWED} from "../api/Api";

export function usePageView(){

    let location = useLocation();

    async function notify(){

        await axios.get(
            PAGE_VIEWED
        );

    }

    React.useEffect(() => {
        notify();
    }, [location]);
}